import React, { useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";

function OrderMap(props) {
  const [coordinate, setCoordinate] = useState([]);
  const [polyline, setPolyline] = useState([]);
  const [bounds, setBounds] = useState(new props.google.maps.LatLngBounds())
  console.log("getCoordinatesBasedOnUnlocoinmap", { props })
  console.log("inside map")
  useEffect(() => {
    const coor = []
    if (props.originCoor.Lat) {
      coor.push(props.originCoor)
    }

    if (props.destinationCoor.Lat) {
      coor.push(props.destinationCoor)

    }
    const arr = [];
    let bound = new props.google.maps.LatLngBounds()

    coor.map((ele, index) => {
      const obj = {
        lat: parseFloat(ele.Lat),
        lng: parseFloat(ele.Lng),
      }
      arr.push(obj);
      bound.extend(obj);
    });
    setCoordinate(coor);

    setPolyline([...arr]);
    setBounds(bound)
  }, [props]);

  return (
    <Map
      google={props.google}
      style={{ width: "100%", height: "100%", position: "relative" }}
      className={"map"}
      // center={center}
      bounds={bounds}
    >
      {!props.loading &&
        coordinate.length != 0 &&
        coordinate.map((item) => {
          const title = `PortName: ${item.PortName}( ${item.Code})`;

          console.log("cooro", item)
          return (
            <Marker
              title={title}
              // name={"SOMA"}
              position={{
                lat: parseFloat(item.Lat),
                lng: item.Lng,
              }}
            />
          );
        })}
      {polyline.length != 0 && (
        <Polyline
          path={polyline}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2}
          fillColor="#0000FF"
          fillOpacity={1}
          options={{
            strokeColor: "#ff2527",
            strokeOpacity: 0.75,
            strokeWeight: 2,
          }}
        />
      )}
    </Map>
  );
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyDpfWeLTpZm0lhuv7_s-8cvKv_8sxJUHD0",
})(React.memo(OrderMap));
